export const ENABLE_STRIPE = process.env.REACT_APP_ENABLE_STRIPE === "true";
export const ENABLE_RHI = process.env.REACT_APP_ENABLE_RHI === "true";
